/**
 * Risk-level guidance used when the analyzer didn't return personalized
 * recommendations. Also the source of the one free preview recommendation.
 */
export const fallbackRecommendations = {
  high: [
    'Consider setting firm boundaries around acceptable language.',
    'Document these conversations for your own clarity.',
    'Trust your instincts if you feel unsafe or confused.',
    'Seek support from a professional to navigate these dynamics.',
  ],
  medium: [
    'Try to address these patterns when you are both calm.',
    'Use "I" statements to express how these messages make you feel.',
    'Monitor if these patterns become more frequent over time.',
    'Focus on clear, direct communication to avoid misunderstandings.',
  ],
  low: [
    'Continue fostering open and respectful dialogue.',
    'Address small misunderstandings before they grow.',
    'Keep checking in with each other regularly.',
    'Celebrate the positive aspects of your communication.',
  ],
}

export function getFallbackRecommendations(
  level: 'low' | 'medium' | 'high',
): string[] {
  return fallbackRecommendations[level]
}
